import React from 'react';
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
} from 'reactstrap';

import { Intl } from 'components';

export default React.memo( ( {
  pageIndex, canPreviousPage, previousPage,
  canNextPage, nextPage, pageCount, leftPaginationContent,
} ) => (
  ( canNextPage || canPreviousPage || leftPaginationContent )
    ? (
      <nav aria-label="...">
        <Row className="justify-content-end align-items-center">
          {!!leftPaginationContent
          && (
          <Col md>
            {leftPaginationContent}
          </Col>
          )}
          {( canNextPage || canPreviousPage )
            ? (
              <>
                <Col md="auto" className="pr-0">
                  <span className="text-sm table-pagination-label">
                    <Intl id="tablePaginationLabel" values={{ page: pageIndex + 1, totalPages: pageCount }} />
                  </span>
                </Col>
                <Col md="auto" className="pt-2 pt-md-0">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem
                      onClick={() => previousPage()}
                      disabled={!canPreviousPage}
                    >
                      <PaginationLink tabIndex="-1" type="button">
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>

                    <PaginationItem active>
                      <PaginationLink tabIndex="-1" type="button">
                        {pageIndex + 1}
                      </PaginationLink>
                    </PaginationItem>

                    <PaginationItem
                      onClick={() => nextPage()}
                      disabled={!canNextPage}
                    >
                      <PaginationLink type="button">
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
              </>
            ) : null}
        </Row>
      </nav>
    ) : null
) );
